<template>
  <div>
    <SpecificPlatformSelector
      v-for="(platform, index) in modelValue"
      :key="index"
      :platform="platform"
      :index="index"
      :available-platforms="availablePlatforms"
      @update="updateSpecific"
      @remove="removeSpecific"
    />
    <el-button
      v-if="availablePlatforms.length > 0"
      size="small"
      @click.prevent="addSpecificPlatform"
    >
      Add
    </el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import SpecificPlatformSelector from './SpecificPlatformSelector.vue'
import { Platform, PlatformKey, SpecificVersion } from '@/api/types'

export default defineComponent({
  name: 'SpecificPlatformsSelector',
  components: {
    SpecificPlatformSelector
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const specifiedPlatforms = computed<Platform[]>(() => {
      return (props.modelValue as Array<SpecificVersion<Platform>>).map(
        (specificPlatform: SpecificVersion<Platform>) => specificPlatform.id
      )
    })

    const availablePlatforms = computed<Platform[]>(() => {
      const result: Platform[] = []
      for (const platform in Platform) {
        const platformId = Platform[platform as PlatformKey]
        if (specifiedPlatforms.value.indexOf(platformId as Platform) < 0) {
          result.push(platformId as Platform)
        }
      }
      return result
    })

    function addSpecificPlatform() {
      if (availablePlatforms.value.length === 0) {
        return
      }
      const newSpecific: SpecificVersion<Platform> = {
        id: availablePlatforms.value[0],
        comparison: '>',
        version: '1.0.0'
      }
      context.emit('update:modelValue', props.modelValue.concat(newSpecific))
    }

    function updateSpecific(payload: {
      index: number
      specific: SpecificVersion<Platform>
    }) {
      // Copy props, and they update, to avoid weird issues with reactivity
      const updatedSpecifics = props.modelValue.slice(0)
      updatedSpecifics[payload.index] = payload.specific
      context.emit('update:modelValue', updatedSpecifics)
    }

    function removeSpecific(index: number) {
      const removed = props.modelValue.filter((_, i) => i !== index)
      context.emit('update:modelValue', removed)
    }

    return {
      addSpecificPlatform,
      specifiedPlatforms,
      availablePlatforms,
      updateSpecific,
      removeSpecific
    }
  }
})
</script>
